import common from '@locales/common'

export default {
  install(Vue) {
    Vue.mixin({
      created() {
        // title description
        if (this.$route && this.$route.params.lang) {
          document.title = common[this.$route.params.lang]['title.result']
          document.querySelector('meta[name="description"]').content = common[this.$route.params.lang]['description002']
          document.querySelector('meta[property="og:site_name"]').content = common[this.$route.params.lang]['title.result']
          document.querySelector('meta[property="og:title"]').content = common[this.$route.params.lang]['title.result']
          document.querySelector('meta[property="og:description"]').content = common[this.$route.params.lang]['description002']
          document.querySelector('meta[property="twitter:title"]').content = common[this.$route.params.lang]['title.result']
          document.querySelector('meta[property="twitter:description"]').content = common[this.$route.params.lang]['description002']
        }
      },
    })
    Vue.prototype.$meta = function (meta) {
      document.title = meta.title
      document.querySelector('meta[name="description"]').content = meta.description
      document.querySelector('meta[property="og:site_name"]').content = meta.title
      document.querySelector('meta[property="og:title"]').content = meta.title
      document.querySelector('meta[property="og:description"]').content = meta.description
      document.querySelector('meta[property="twitter:title"]').content = meta.title
      document.querySelector('meta[property="twitter:description"]').content = meta.description
    }
  }
}